import { BatteryFull } from "@untitledui/icons";
import type { ProgramBatteryDetails } from "../../state/api.types";
import { formatCurrency } from "../../utilities/currency";
import { isNonZeroNumberString } from "../../utilities/stringHelpers";
import { ViewOnlyField } from "./ViewOnlyField";

type EditBatteryProgramProps = {
  program: ProgramBatteryDetails;
};

export const EditBatteryProgram = ({ program }: EditBatteryProgramProps) => {
  return (
    <div className="flex flex-col gap-2xl">
      <div className="flex flex-col gap-sm">
        <div className="flex w-full flex-row items-center gap-md">
          <BatteryFull />
          <div className="w-full text-lg font-semibold">Battery program</div>
        </div>
        <div className="text-sm text-tertiary">
          Earn commission and lower bills in exchange for battery access.
          Customers still use their battery during outages.
        </div>
      </div>
      <ViewOnlyField
        label="Monthly customer credit"
        value={
          program.monthly_credit_dollars &&
          isNonZeroNumberString(program.monthly_credit_dollars)
            ? formatCurrency(program.monthly_credit_dollars)
            : program.monthly_credit_per_kwh_dollars &&
                isNonZeroNumberString(program.monthly_credit_per_kwh_dollars)
              ? `${formatCurrency(program.monthly_credit_per_kwh_dollars)} per kWh`
              : "$0.00"
        }
        description="Reach out to us to modify the customer's credit for participating in battery program."
      />
    </div>
  );
};
